module.exports = __webpack_public_path__ + "static/media/8_r_lamp_53.7_1.39.07575064.png";